import React from 'react';

import {Box, Stack} from 'views/components';

import EventHeaderSkeleton from './EventHeaderSkeleton';
import CaregiverTileSkeleton from './CaregiverTileSkeleton';
import ClientTileSkeleton from './ClientTileSkeleton';
import TimeTileSkeleton from './TimeTileSkeleton';
import NotesTileSkeleton from './NotesTileSkeleton';
import EventTimelineTileSkeleton from './EventTimelineTileSkeleton';

const LoadingScreen = () => {
  return (
    <Box sx={{p: 3, margin: 'auto'}}>
      <EventHeaderSkeleton />
      <Stack
        direction={{xs: 'column', sm: 'row'}}
        spacing={2}
        mb={2}
      >
        <Box sx={{flex: 1, width: {xs: '100%', sm: '50%'}}}>
          <ClientTileSkeleton />
        </Box>
        <Box sx={{flex: 1, width: {xs: '100%', sm: '50%'}}}>
          <CaregiverTileSkeleton />
        </Box>
      </Stack>
      <TimeTileSkeleton />
      <NotesTileSkeleton />
      <EventTimelineTileSkeleton />
    </Box>
  );
};

export default LoadingScreen;
